export * from './ConfigurationCompletedThankYouPage';
